import Swiper, { Navigation, Pagination } from 'swiper'

const CarouselDescriptive = () => {
  const swiper = new Swiper('.descriptive-slider', {
    modules: [Navigation, Pagination],

    slidesPerView: 4,
    spaceBetween: 30,
    slidesOffsetAfter: 38,
    slidesPerView: 'auto',
    
    navigation: {
      nextEl: '.carouseldescriptive-navigation .slider-button-next',
      prevEl: '.carouseldescriptive-navigation .slider-button-prev',
    },
  })
}

export default CarouselDescriptive
